import { GoANotification, GoANotificationType } from '@abgov/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../state/store';
import { removeNotification } from '../../state/slices/notificationSlice';

export enum NotificationType {
  informationSaveGuestId,
  informationGeneric,
  importantValidationError,
  importantGenericError,
  importantWarning,
  success,
}
export interface NotificationComponentProps {}

export const NotificationComponent = ({}: NotificationComponentProps) => {
  const dispatch = useDispatch();

  let componentNotificationType: GoANotificationType = 'information';

  let notifications = useSelector(
    (state: RootState) => state.notifications.notifications,
  );

  const handleOnDismiss = (id: string): (() => void) | undefined => {
    return () => {
      dispatch(removeNotification(id));
    };
  };

  const notificationFactory = (
    notificationType: NotificationType,
    body?: string,
  ): JSX.Element => {
    if (notificationType === NotificationType.informationGeneric) {
      componentNotificationType = 'information';
      return InformationGenetirNotificationComponent({ body: body });
    }
    if (notificationType === NotificationType.informationSaveGuestId) {
      componentNotificationType = 'information';
      return InformationSaveGuestIdNotificationComponent({});
    }

    if (notificationType === NotificationType.importantValidationError) {
      componentNotificationType = 'emergency';
      return EmergencyValidationErrorNotificationComponent({ body: body });
    }

    if (notificationType === NotificationType.importantGenericError) {
      componentNotificationType = 'emergency';
      return EmergencyGenericErrorNotificationComponent({ body: body });
    }

    if (notificationType === NotificationType.importantWarning) {
      componentNotificationType = 'important';
      return ImportantWarningNotificationComponent({ body: body });
    }

    return <></>;
  };

  return (
    <div>
      {notifications.map((notification) => {
        const notificationComponent = notificationFactory(
          notification.notificationType,
          notification.body,
        );
        return (
          <GoANotification
            key={notification.id}
            onDismiss={handleOnDismiss(notification.id)}
            type={componentNotificationType}
          >
            {notificationComponent}
          </GoANotification>
        );
      })}
    </div>
  );
};

interface NotificationProps {
  body?: string;
}

const InformationGenetirNotificationComponent = ({
  body,
}: NotificationProps) => {
  return <div>{body}</div>;
};

const EmergencyGenericErrorNotificationComponent = ({
  body,
}: NotificationProps) => {
  return <div>{body}</div>;
};

const EmergencyValidationErrorNotificationComponent = ({
  body,
}: NotificationProps) => {
  return <div>{body}</div>;
};

const ImportantWarningNotificationComponent = ({ body }: NotificationProps) => {
  return <div>{body}</div>;
};

const InformationSaveGuestIdNotificationComponent = ({}: NotificationProps) => {
  return (
    <div>
      Reminder to save your guest ID if your verified account is pending, you'll
      need your guest ID to log back into Report My Collision.{' '}
      <a style={{ color: 'white' }} href={'..'}>
        Save my guest ID now
      </a>
    </div>
  );
};
